import { useMutation } from 'react-query';
import request from '../helpers/request';

const getTransportCheckPermit = async (value) => {
  return await request.get(
    '/HousingStock/transport/check_permit',
    value,
    'При проверке наличия пропусков у ТС произошла ошибка',
    'Error'
  );
};

const useTransportCheckPermit = () => {
  return useMutation((params) => getTransportCheckPermit(params), {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });
};

export default useTransportCheckPermit;
